import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import HowItWorks from './components/HowItWorks';
import Advantages from './components/Advantages';
import Portfolio from './components/Portfolio';
import Contact from './components/Contact';

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <HowItWorks />
        <Advantages />
        <Portfolio />
        <Contact />
      </main>
      <footer className="bg-[#1E3A5F] text-white py-8 text-center">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-center gap-2 mb-3">
            <svg width="24" height="24" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="2" y="2" width="15" height="15" fill="#FF9933" rx="2"/>
              <rect x="23" y="23" width="15" height="15" fill="#FF9933" rx="2"/>
              <path d="M20 8 L32 8 C36 8 38 12 38 16 L38 24 C38 28 36 32 32 32 L20 32 L20 8 Z" fill="white"/>
              <circle cx="27" cy="20" r="6" fill="#1E3A5F"/>
            </svg>
            <span className="text-sm opacity-80" style={{ fontFamily: "'Inter', sans-serif" }}>
              © 2025 <span className="font-semibold">LD Digital</span> - Création de sites internet professionnels
            </span>
          </div>
          <div className="flex justify-center gap-6 flex-wrap text-sm">
            <a 
              href="/mentions-legales.html" 
              className="opacity-80 hover:opacity-100 hover:text-[#FF9933] transition-all duration-200"
            >
              Mentions légales
            </a>
            <span className="opacity-50">•</span>
            <a 
              href="/confidentialite.html" 
              className="opacity-80 hover:opacity-100 hover:text-[#FF9933] transition-all duration-200"
            >
              Confidentialité
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
